import { Directive, effect, ElementRef, inject, input } from '@angular/core';

/**
 * Directive to set the indeterminate property on a checkbox input element. The indeterminate property cannot be set via
 * HTML attribute, only via JavaScript.
 *
 * @example
 *   ```html
 *   <input type="checkbox" [hxIndeterminate]="isPartiallySelected" />
 *   ```;
 */
@Directive({
  selector: 'input[type="checkbox"][hxIndeterminate]',
  standalone: true,
})
export class HxCheckboxIndeterminate {
  private readonly elementRef = inject(ElementRef<HTMLInputElement>);

  /** Whether the checkbox should be in indeterminate state */
  readonly hxIndeterminate = input<boolean>(false);

  constructor() {
    effect(() => {
      this.elementRef.nativeElement.indeterminate = this.hxIndeterminate();
    });
  }
}
